module.exports = __webpack_public_path__ + "static/intro-594d206494913f4eb1dde2ecd6bd6a39.jpg";